import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
  icon?: JSX.Element;
}

const PrimaryButton = ({ className, children, ...props }: ButtonProps) => {
  return (
    <button
      className={`font-gtAmerica-medium flex ${
        props.icon && "gap-2"
      } transition-custom items-center px-8 py-2 text-[16px] text-white transition-all duration-200 rounded-lg  ${
        className ? className : ""
      }`}
      {...props}
    >
      {children}
      <span className="transition-custom">{props.icon}</span>
    </button>
  );
};

export default PrimaryButton;
